import * as React from 'react';
import {useDispatch} from 'react-redux';

import {Modal} from 'shells/modal/modal';

import type {LimitedType} from 'nutshell-graphql-types';

import {FeatureLimitsModalContent} from './feature-limits-modal-content';
import {openModalForType} from './limits-actions';
import {useGetLimitsByType} from './use-get-limits-by-type';

type Props = {
    modalType: LimitedType;
};

export function IndividualFeatureLimitsModal(props: Props) {
    const dispatch = useDispatch();
    const {limits} = useGetLimitsByType(props.modalType);
    const {currentPlanName, currentPlanLimit, humanReadableType, tierPlanLimit} = limits || {};

    const handleClose = () => {
        dispatch(openModalForType(null));
    };
    let displayString = humanReadableType;
    if (currentPlanLimit === 1) {
        // Get proper singular form of words ending in 'ies' vs 's'
        if (
            // @ts-expect-error
            humanReadableType.slice(humanReadableType.length - 3, humanReadableType.length) ===
            'ies'
        ) {
            // @ts-expect-error
            displayString = `${humanReadableType.slice(0, humanReadableType.length - 3)}y`;
        }
        // @ts-expect-error
        displayString = humanReadableType.slice(0, humanReadableType.length - 1);
    }

    return (
        <Modal
            trapFocus={true}
            // @ts-expect-error
            isOpen={Boolean(props.modalType) && limits}
            onClose={handleClose}
            maxHeight={575}
            headerText={`Your ${currentPlanName} plan supports ${
                typeof tierPlanLimit === 'number' ? `up to ${tierPlanLimit}` : 'unlimited'
            } ${displayString}`}
        >
            {limits ? (
                <FeatureLimitsModalContent
                    displayString={displayString}
                    onClose={handleClose}
                    {...limits}
                />
            ) : undefined}
        </Modal>
    );
}
